module.exports = __webpack_public_path__ + "static/media/partner1.959358bf.png";